import React from "react";
import { FormattedMessage } from "react-intl";
import { Stack, Typography, Button } from "@mui/material";

import SuccessBG from "@/assets/bg-success.png";

import GetImages from "../GetImages";
import Dialog from "../Dialog";

import { IDoctorScheduleConsultationType } from "@/models/doctor";

interface AppointmentSuccessProps {
  type: IDoctorScheduleConsultationType;
  slotNo?: number;
  name: string;
  experienceYears: number;
  speciality: string;
  dateSlotTime: string;
  qualificationDetails: any[];
  isSmallScreen: boolean;
  onGoToHome: () => void;
}

const AppointmentSuccess = (props: AppointmentSuccessProps) => {
  const {
    type,
    slotNo = "",
    onGoToHome,
    name,
    experienceYears,
    speciality,
    dateSlotTime,
    qualificationDetails,
    isSmallScreen,
  } = props;

  const successUI = () => (
    <Stack gap={1} p={2}>
      {/* Success Icon Section */}
      <Stack justifyContent="center" alignItems="center" gap={0.5}>
        <Stack
          alignItems="center"
          justifyContent="center"
          sx={{
            backgroundImage: `url(${SuccessBG})`,
            backgroundSize: "cover",
            height: 70,
            width: 70,
          }}
        >
          {type === IDoctorScheduleConsultationType.VIDEO_CALL ? (
            <GetImages
              name="AppointmentBookedLikeIcon"
              width="20"
              height="20"
            />
          ) : (
            <Typography
              textAlign="center"
              variant="h6"
              color="var(--neutral-100)"
            >
              {slotNo}
            </Typography>
          )}
        </Stack>

        {type === IDoctorScheduleConsultationType.IN_CLINIC && (
          <Typography variant="subtitle2" fontWeight={400} color="secondary">
            <FormattedMessage
              id="slot_alloted"
              defaultMessage="Slot Number Alloted"
            />
          </Typography>
        )}

        <Typography variant="subtitle2" fontWeight={400} color="success.main">
          {type === IDoctorScheduleConsultationType.VIDEO_CALL ? (
            <FormattedMessage
              id="video_consultation_booked"
              defaultMessage="Your Video Consultation is Confirmed"
            />
          ) : (
            <FormattedMessage
              id="clinit_appointment_success"
              defaultMessage="Your Clinic Visit is successful Booked"
            />
          )}
        </Typography>
      </Stack>

      {/* Doctor Details Section */}
      <Stack justifyContent="center" alignItems="center">
        <Typography variant="subtitle1" fontWeight={500}>
          {name}
        </Typography>

        <Stack
          direction="row"
          alignItems="center"
          justifyContent="center"
          gap={1}
          flexWrap="wrap"
          width="100%"
        >
          <Typography variant="caption" color="secondary" noWrap>
            {experienceYears} Yrs
          </Typography>
          &bull;
          <Typography variant="caption" color="secondary" noWrap>
            {speciality}
          </Typography>
          {qualificationDetails?.map((item, index) => (
            <span key={index}>
              {item.degree_name && <>&bull; </>}
              <Typography variant="caption" color="secondary" noWrap>
                {item.degree_name}
              </Typography>
            </span>
          ))}
        </Stack>

        <Typography variant="subtitle1" fontWeight={500}>
          {dateSlotTime}
        </Typography>
      </Stack>

      {/* Action Button */}
      <Button
        variant="contained"
        color="primary"
        sx={{ py: 1, width: "80%", mx: "auto" }}
        onClick={onGoToHome}
      >
        <FormattedMessage id="goto_homepage" defaultMessage="Go to Home Page" />
      </Button>
    </Stack>
  );
  return (
    <Dialog
      isOpen={true}
      paperProps={{
        sx: {
          width: !isSmallScreen ? "40rem" : "auto",
        },
      }}
    >
      {successUI()}
    </Dialog>
  );
};

export default AppointmentSuccess;
